import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from 'src/environments/environment';
import { ClassificationWebComponentModule } from 'src/modules/classification/classification.webcomponent.module';

import 'codemirror/mode/xml/xml';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(ClassificationWebComponentModule, {
    // defaultEncapsulation: ViewEncapsulation.None,
  })
  .catch((err) => console.log(err));
